import React, {useEffect, useState} from "react"
import TableData from "./TableData";
import Widget from "../../components/widget";
import {apiGetKioskLog} from "./Actions";


const Kiosk = () => {

    let [loading, setLoading] = useState(false)
    let [data, setData] = useState(null)

    useEffect(() => {
        getKioskLog()
    }, [])

    const getKioskLog = () => {
        setLoading(true)
        apiGetKioskLog((data) => {
            setData(data)
            setLoading(false)
        }, (err) => {
            //console.log(err)
        })
    }

    return (
        <>
            <Widget>
                <div className={"flex flex-row text-black"}>
                    <h5 className={"align-middle"}>Logy z kiosku</h5>
                    <span className="ml-auto"></span>
                    <div className={"flex"}>
                    </div>
                </div>
            </Widget>
            <TableData data={data} loading={loading}/>
        </>
    )

}

export default Kiosk
